import './MmaAthleteInfoView.scss';
import Control from "../../1. Core/Control";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import Delegate from "../../1. Core/Delegate";
import NP from "../../1. Core/NP";
import IconToggleButton from "../../1. Core/Controls/IconToggleButton/IconToggleButton";
import {ServerAPI} from "../../1. Core/ServerAPI";
import {getPieChartData, IBattlesResponse, IPunchesData} from "./BoxerDashboard";
import MmaPunchesBodyView, {IMmaBodyData} from "./MmaPunchesBodyView";
import {export2pdf, getWeightStringById, secondsToTime} from "../Util";
import Label from "../../1. Core/Controls/Label/Label";
import Select, {ISelectItemArgs} from "../../1. Core/Controls/Select/Select";
import moment = require("moment");
import {Moment} from "moment";
import {IAthlete, IBattle, RecordData, SportType} from "../types";
import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import DataTable from "../../1. Core/Controls/DataTable/DataTable";
import {loadFile} from '../../1. Core/ScriptLoader';
import {hideWaiter, showWaiterAnyWay} from '../../Entries/battlehtml';

interface IMMAAthleteProfileReportData {
	PhotoUrl: string;
	OpponentPhotoUrl: string;
	FlagUrl: string;
	StrikesAccuracy: IPunchesData;
	StrikesAccuracyTable: IPunchesData;
	StrikesTypes: IPunchesData;
	StrikesTypesTable: IPunchesData;
	StrikesTypesLanded: IPunchesData;
	StrikesTypesLandedTable: IPunchesData;
	StrikesEfficiencyTable: IPunchesData;
	StrikesSpeedAll: number;
	StrikesSpeedLanded: number;
	StrikesZones: IMmaBodyData;
	TakedownsAccuracy: IPunchesData;
	TakedownsAccuracyTable: IPunchesData;
	PositionTime: IPunchesData;
	PositionTimeTable: IPunchesData;
	ControlTable: IPunchesData;
	DefensesTypes: IPunchesData;
	DefensesTypesTable: IPunchesData;
	DefensesEfficiency: number;
	MissedStrikesZones: IMmaBodyData;
	TakedownsDefense: IPunchesData;
	TakedownsDefenseTable: IPunchesData;
}

export default class MmaAthleteDashboard extends Control {
	private _loading: number;
	private _topAppBar: TopAppBar;
	private _battleSelect: Select;
	private _oldAppBarCaption: string;
	private EvClosed: Delegate;
	private _Athlete: IAthlete;
	private opponentPhotoUrl: string;
	private _battles: IBattle[];
	private _mainContainer: HTMLDivElement;

	private photoFlagBlock: HTMLDivElement;
	private photoPart: HTMLDivElement;
	private photo: HTMLDivElement;

	private infoHeightEl: HTMLElement;
	private infoWeightEl: HTMLElement;
	private infoWinRecordEl: HTMLElement;
	private infoLoseRecordEl: HTMLElement;
	private infoDrawRecordEl: HTMLElement;
	private infoBaseStyleEl: HTMLElement;
	private flagPart: HTMLDivElement;
	private flag: HTMLDivElement;

	private battlePhotosBlock: HTMLDivElement;
	private photoLeftPart: HTMLDivElement;
	private battleAthleteNameEl: HTMLDivElement;
	private photoLeft: HTMLDivElement;

	private battleInfoTournamentEl: HTMLDivElement;
	private battleInfoDateEl: HTMLDivElement;
	private battleInfoWinnerEl: HTMLDivElement;
	private battleInfoWinEl: HTMLDivElement;
	private photoRightPart: HTMLDivElement;
	private battleOpponentNameEl: HTMLDivElement;
	private photoRight: HTMLDivElement;


	private strikesAccuracyBlock: HTMLDivElement;
	private strikesAccuracyChart: any;
	private strikesAccuracyChartWrapper: HTMLDivElement;
	private strikesAccuracyTable: HTMLTableElement;
	private strikesAccuracyTableWrapper: HTMLDivElement;

	private strikesTypesBlock: HTMLDivElement;
	private strikesTypesChart: any;
	private strikesTypesChartWrapper: HTMLDivElement;
	private strikesTypesTable: HTMLTableElement;
	private strikesTypesTableWrapper: HTMLDivElement;

	private strikesTypesLandedBlock: HTMLDivElement;
	private strikesTypesLandedChart: any;
	private strikesTypesLandedChartWrapper: HTMLDivElement;
	private strikesTypesLandedTable: HTMLTableElement;
	private strikesTypesLandedTableWrapper: HTMLDivElement;

	private strikesEfficiencyBlock: HTMLDivElement;
	private strikesEfficiencyTable: HTMLTableElement;
	private strikesEfficiencyTableWrapper: HTMLDivElement;

	private strikesSpeedBlock: HTMLDivElement;
	private strikesSpeedEl: HTMLDivElement;
	private strikesSpeedLandedEl: HTMLDivElement;

	private strikesZonesBlock: HTMLDivElement;
	private strikesZonesViewThrown: MmaPunchesBodyView;
	private strikesZonesViewLanded: MmaPunchesBodyView;

	private takedownsAccuracyBlock: HTMLDivElement;
	private takedownsAccuracyChart: any;
	private takedownsAccuracyChartWrapper: HTMLDivElement;
	private takedownsAccuracyTable: HTMLTableElement;
	private takedownsAccuracyTableWrapper: HTMLDivElement;

	private positionTimeBlock: HTMLDivElement;
	private positionTimeChart: any;
	private positionTimeChartWrapper: HTMLDivElement;
	private positionTimeTable: HTMLTableElement;
	private positionTimeTableWrapper: HTMLDivElement;

	private controlBlock: HTMLDivElement;
	private controlTable: HTMLTableElement;
	private controlTableWrapper: HTMLDivElement;

	private defensesTypesBlock: HTMLDivElement;
	private defensesTypesChart: any;
	private defensesTypesChartWrapper: HTMLDivElement;
	private defensesTypesTable: HTMLTableElement;
	private defensesTypesTableWrapper: HTMLDivElement;

	private defensesEfficiencyBlock: HTMLDivElement;
	private defensesEfficiencyEl: HTMLDivElement;

	private missedStrikesZonesBlock: HTMLDivElement;
	private missedStrikesZonesViewThrown: MmaPunchesBodyView;
	private missedStrikesZonesViewLanded: MmaPunchesBodyView;

	private takedownsDefenseBlock: HTMLDivElement;
	private takedownsDefenseChart: any;
	private takedownsDefenseChartWrapper: HTMLDivElement;
	private takedownsDefenseTable: HTMLTableElement;
	private takedownsDefenseTableWrapper: HTMLDivElement;

	private _caption: HTMLDivElement;

	private _preRenderWidth: number;
	private recordData: {
		WIN: number,
		DRAW: number,
		LOSE: number,
		CANCELLED: number
	};

	private recordDataStat: RecordData[];
	private infoCancelledRecordEl: HTMLTableCellElement;
	private infoNickNameEl: HTMLElement;
	private infoarmSpanEl: HTMLElement;
	private infoAgeEl: HTMLElement;
	private infoBoutCount: HTMLElement;
	private analInfoEl: HTMLElement;

	_initFields(settings: object)
	{
		this.EvClosed = new Delegate();
		this._Athlete = null;
		super._initFields(settings);
	}

	constructor(settings?: object)
	{
		super(settings);
		this._loading = 0;
		this._battles = [];
		this._render();
	}

	_render()
	{
		this._initComponent('<div class="mma-athlete-info-view"></div>');
		this.addClass(this._Class);

		this._topAppBar = new TopAppBar({
			Class: 'mma-athlete-info-view__top-app-bar top-app-bar--no-shadow top-app-bar--light top-app-bar--white',
			Caption: '',
			ParentNode: this._root,
			MainButton: {
				FontImage: NP.FontImages.close,
				EvClick: () => this.EvClosed.fire(this)
			},
			RightItems: [
				new Label({RK: 'Battle'}),
				this._battleSelect = new Select({
					Width: 220,
					Value: -1,
					Items: [{
						Value: -1,
						RK: 'All'
					}],
					EvItemSelected: this._onBattleSelected
				}),
				new IconToggleButton({
					FontImage: NP.FontImages.download,
					EvClick: () => this.newExportClick()
				})
			]
		});


		this._mainContainer = NP.createNode(this._root, 'mma-athlete-info-view__main-container');

		this._caption = NP.createNode(this._mainContainer, 'mma-athlete-info-view__caption');
		//this._caption.innerText = '';

		// Photo & Flag
		this.photoFlagBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__photo-flag-block');
		this.photoPart = NP.createNode(this.photoFlagBlock, 'mma-athlete-info-view__block-part mma-athlete-info-view__block-part--third');
		let photoWrapper = NP.createNode(this.photoPart, 'mma-athlete-info-view__photo-wrapper');
		this.photo = NP.createNode(photoWrapper, 'mma-athlete-info-view__photo');

		let infoPart = NP.createNode(this.photoFlagBlock, 'mma-athlete-info-view__block-part mma-athlete-info-view__block-part--third');
		let infoWrapper = NP.createNode(infoPart, 'mma-athlete-info-view__info-wrapper');
		let info = this.createInfoNode(infoWrapper);

		this.flagPart = NP.createNode(this.photoFlagBlock, 'mma-athlete-info-view__block-part mma-athlete-info-view__block-part--third');
		let flagWrapper = NP.createNode(this.flagPart, 'mma-athlete-info-view__flag-wrapper');
		this.flag = NP.createNode(flagWrapper, 'mma-athlete-info-view__flag');

		// Battle Athletes Photos
		this.battlePhotosBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__battle-photos-block');
		this.photoLeftPart = NP.createNode(this.battlePhotosBlock, 'mma-athlete-info-view__block-part mma-athlete-info-view__block-part--third');
		this.battleAthleteNameEl = NP.createNode(this.photoLeftPart, 'mma-athlete-info-view__name mma-athlete-info-view__name-main');
		let photoLeftWrapper = NP.createNode(this.photoLeftPart, 'mma-athlete-info-view__photo-wrapper');
		this.photoLeft = NP.createNode(photoLeftWrapper, 'mma-athlete-info-view__photo');

		let battleInfoPart = NP.createNode(this.battlePhotosBlock, 'mma-athlete-info-view__block-part mma-athlete-info-view__block-part--third mma-athlete-info-view__battle-info-part');
		let battleInfoWrapper = NP.createNode(battleInfoPart, 'mma-athlete-info-view__info-wrapper');
		let battleInfo = this.createBattleInfoNode(battleInfoWrapper);

		this.photoRightPart = NP.createNode(this.battlePhotosBlock, 'mma-athlete-info-view__block-part mma-athlete-info-view__block-part--third');
		this.battleOpponentNameEl = NP.createNode(this.photoRightPart, 'mma-athlete-info-view__name mma-athlete-info-view__name-opponent');
		let photoRightWrapper = NP.createNode(this.photoRightPart, 'mma-athlete-info-view__photo-wrapper');
		this.photoRight = NP.createNode(photoRightWrapper, 'mma-athlete-info-view__photo');


		NP.hideNode(this.battlePhotosBlock);

		// 1. Strikes
		this.strikesAccuracyBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__block mma-athlete-info-view__strikes-accuracy-block');
		let strikesAccuracyCaption = NP.createNode(this.strikesAccuracyBlock, 'mma-athlete-info-view__block-caption');
		strikesAccuracyCaption.innerText = NP.RM.getString("MMAAthleteProfileReport_StrikesAccuracyCaption");
		let strikesAccuracyContent = NP.createNode(this.strikesAccuracyBlock, 'mma-athlete-info-view__block-content');
		let strikesAccuracyPart1 = NP.createNode(strikesAccuracyContent, 'mma-athlete-info-view__block-part');
		let strikesAccuracyPart2 = NP.createNode(strikesAccuracyContent, 'mma-athlete-info-view__block-part mma-athlete-info-view__block-part-table');
		this.strikesAccuracyChartWrapper = NP.createNode(strikesAccuracyPart1, 'mma-athlete-info-view__chart-wrapper mma-athlete-info-view__chart-wrapper-strikes-accuracy');
		this.strikesAccuracyTableWrapper = NP.createNode(strikesAccuracyPart2, 'mma-athlete-info-view__table-wrapper mma-athlete-info-view__table-wrapper-strikes-accuracy');

		// 2. Strikes types
		this.strikesTypesBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__block mma-athlete-info-view__strikes-types-block');
		let strikesTypesCaption = NP.createNode(this.strikesTypesBlock, 'mma-athlete-info-view__block-caption');
		strikesTypesCaption.innerText = NP.RM.getString("MMAAthleteProfileReport_StrikesTypesCaption");
		let strikesTypesContent = NP.createNode(this.strikesTypesBlock, 'mma-athlete-info-view__block-content');
		let strikesTypesPart1 = NP.createNode(strikesTypesContent, 'mma-athlete-info-view__block-part');
		let strikesTypesPart2 = NP.createNode(strikesTypesContent, 'mma-athlete-info-view__block-part mma-athlete-info-view__block-part-table');
		this.strikesTypesChartWrapper = NP.createNode(strikesTypesPart1, 'mma-athlete-info-view__chart-wrapper mma-athlete-info-view__chart-wrapper-strikes-types');
		this.strikesTypesTableWrapper = NP.createNode(strikesTypesPart2, 'mma-athlete-info-view__table-wrapper mma-athlete-info-view__table-wrapper-strikes-types');

		// 3. Landed strikes types

		NP.createNode(this._mainContainer).style.pageBreakBefore = 'always';

		this.strikesTypesLandedBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__block mma-athlete-info-view__strikes-types-landed-block');
		let strikesTypesLandedCaption = NP.createNode(this.strikesTypesLandedBlock, 'mma-athlete-info-view__block-caption');
		strikesTypesLandedCaption.innerText = NP.RM.getString("MMAAthleteProfileReport_LandedStrikesTypesCaption");
		let strikesTypesLandedContent = NP.createNode(this.strikesTypesLandedBlock, 'mma-athlete-info-view__block-content');
		let strikesTypesLandedPart1 = NP.createNode(strikesTypesLandedContent, 'mma-athlete-info-view__block-part');
		let strikesTypesLandedPart2 = NP.createNode(strikesTypesLandedContent, 'mma-athlete-info-view__block-part mma-athlete-info-view__block-part-table');
		this.strikesTypesLandedChartWrapper = NP.createNode(strikesTypesLandedPart1, 'mma-athlete-info-view__chart-wrapper mma-athlete-info-view__chart-wrapper-strikes-types-landed');
		this.strikesTypesLandedTableWrapper = NP.createNode(strikesTypesLandedPart2, 'mma-athlete-info-view__table-wrapper mma-athlete-info-view__table-wrapper-strikes-types-landed');

		// 4. Strikes efficiency
		this.strikesEfficiencyBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__block mma-athlete-info-view__strikes-efficiency-block');
		let strikesEfficiencyCaption = NP.createNode(this.strikesEfficiencyBlock, 'mma-athlete-info-view__block-caption');
		strikesEfficiencyCaption.innerText = NP.RM.getString("MMAAthleteProfileReport_StrikesEfficiencyCaption");
		let strikesEfficiencyContent = NP.createNode(this.strikesEfficiencyBlock, 'mma-athlete-info-view__block-content');
		this.strikesEfficiencyTableWrapper = NP.createNode(strikesEfficiencyContent, 'mma-athlete-info-view__table-wrapper mma-athlete-info-view__table-wrapper--single mma-athlete-info-view__table-wrapper-strikes-efficiency');

		// 5. Strikes speed
		this.strikesSpeedBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__block mma-athlete-info-view__strikes-speed-block');
		let strikesSpeedCaption = NP.createNode(this.strikesSpeedBlock, 'mma-athlete-info-view__block-caption');
		strikesSpeedCaption.innerText = NP.RM.getString("MMAAthleteProfileReport_StrikesSpeedCaption");
		let strikesSpeedContent = NP.createNode(this.strikesSpeedBlock, 'mma-athlete-info-view__block-content');
		this.strikesSpeedEl = this.createSingleValue(strikesSpeedContent, "", NP.RM.getString("MMAAthleteProfileReport_StrikesSpeedAllCaption"));
		this.strikesSpeedLandedEl = this.createSingleValue(strikesSpeedContent, "", NP.RM.getString("MMAAthleteProfileReport_StrikesSpeedLandedCaption"));

		// 6. Strikes zones
		this.strikesZonesBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__block mma-athlete-info-view__strikes-zones-block');
		let strikesZonesCaption = NP.createNode(this.strikesZonesBlock, 'mma-athlete-info-view__block-caption');
		strikesZonesCaption.innerText = NP.RM.getString("MMAAthleteProfileReport_StrikesZonesCaption");
		let strikesZonesContent = NP.createNode(this.strikesZonesBlock, 'mma-athlete-info-view__block-content mma-athlete-info-view__block-content-strikes-zones');
		let strikesZonesPart1 = NP.createNode(strikesZonesContent, 'mma-athlete-info-view__block-part');
		let strikesZonesPart2 = NP.createNode(strikesZonesContent, 'mma-athlete-info-view__block-part');
		let strikesZonesThrownContainer = NP.createNode(strikesZonesPart1, 'mma-athlete-info-view__mma-punches-body-view-container');
		let strikesZonesThrownCaption = NP.createNode(strikesZonesThrownContainer, 'mma-athlete-info-view__mma-punches-body-view-caption');
		strikesZonesThrownCaption.innerHTML = NP.RM.getString("MMAAthleteProfileReport_StrikesZonesCaptionThrown");
		this.strikesZonesViewThrown = new MmaPunchesBodyView({
			ParentNode: strikesZonesThrownContainer,
			Class: "mma-athlete-info-view__mma-punches-body-view mma-athlete-info-view__mma-punches-body-view-thrown"
		});
		let strikesZonesLandedContainer = NP.createNode(strikesZonesPart2, 'mma-athlete-info-view__mma-punches-body-view-container');
		let strikesZonesLandedCaption = NP.createNode(strikesZonesLandedContainer, 'mma-athlete-info-view__mma-punches-body-view-caption');
		strikesZonesLandedCaption.innerHTML = NP.RM.getString("MMAAthleteProfileReport_StrikesZonesCaptionLanded");
		this.strikesZonesViewLanded = new MmaPunchesBodyView({
			ParentNode: strikesZonesLandedContainer,
			Class: "mma-athlete-info-view__mma-punches-body-view mma-athlete-info-view__mma-punches-body-view-landed"
		});

		// 7. Takedowns
		NP.createNode(this._mainContainer).style.pageBreakBefore = 'always';
		this.takedownsAccuracyBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__block mma-athlete-info-view__takedowns-accuracy-block');
		let takedownsAccuracyCaption = NP.createNode(this.takedownsAccuracyBlock, 'mma-athlete-info-view__block-caption');
		takedownsAccuracyCaption.innerText = NP.RM.getString("MMAAthleteProfileReport_TakedownsAccuracyCaption");
		let takedownsAccuracyContent = NP.createNode(this.takedownsAccuracyBlock, 'mma-athlete-info-view__block-content');
		let takedownsAccuracyPart1 = NP.createNode(takedownsAccuracyContent, 'mma-athlete-info-view__block-part');
		let takedownsAccuracyPart2 = NP.createNode(takedownsAccuracyContent, 'mma-athlete-info-view__block-part mma-athlete-info-view__block-part-table');
		this.takedownsAccuracyChartWrapper = NP.createNode(takedownsAccuracyPart1, 'mma-athlete-info-view__chart-wrapper mma-athlete-info-view__chart-wrapper-takedowns-accuracy');
		this.takedownsAccuracyTableWrapper = NP.createNode(takedownsAccuracyPart2, 'mma-athlete-info-view__table-wrapper mma-athlete-info-view__table-wrapper-takedowns-accuracy');

		// 8. Position time
		this.positionTimeBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__block mma-athlete-info-view__position-time-block');
		let positionTimeCaption = NP.createNode(this.positionTimeBlock, 'mma-athlete-info-view__block-caption');
		positionTimeCaption.innerText = NP.RM.getString("MMAAthleteProfileReport_PositionTimeCaption");
		let positionTimeContent = NP.createNode(this.positionTimeBlock, 'mma-athlete-info-view__block-content');
		let positionTimePart1 = NP.createNode(positionTimeContent, 'mma-athlete-info-view__block-part');
		let positionTimePart2 = NP.createNode(positionTimeContent, 'mma-athlete-info-view__block-part mma-athlete-info-view__block-part-table');
		this.positionTimeChartWrapper = NP.createNode(positionTimePart1, 'mma-athlete-info-view__chart-wrapper mma-athlete-info-view__chart-wrapper-position-time');
		this.positionTimeTableWrapper = NP.createNode(positionTimePart2, 'mma-athlete-info-view__table-wrapper mma-athlete-info-view__table-wrapper-position-time');

		// 9. Control
		this.controlBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__block mma-athlete-info-view__control-block');
		let controlCaption = NP.createNode(this.controlBlock, 'mma-athlete-info-view__block-caption');
		controlCaption.innerText = NP.RM.getString("MMAAthleteProfileReport_ControlCaption");
		let controlContent = NP.createNode(this.controlBlock, 'mma-athlete-info-view__block-content');
		this.controlTableWrapper = NP.createNode(controlContent, 'mma-athlete-info-view__table-wrapper mma-athlete-info-view__table-wrapper--single mma-athlete-info-view__table-wrapper-control');

		// 10. Defenses types
		this.defensesTypesBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__block mma-athlete-info-view__defenses-types-block');
		let defensesTypesCaption = NP.createNode(this.defensesTypesBlock, 'mma-athlete-info-view__block-caption');
		defensesTypesCaption.innerText = NP.RM.getString("MMAAthleteProfileReport_DefensesTypesCaption");
		let defensesTypesContent = NP.createNode(this.defensesTypesBlock, 'mma-athlete-info-view__block-content');
		let defensesTypesPart1 = NP.createNode(defensesTypesContent, 'mma-athlete-info-view__block-part');
		let defensesTypesPart2 = NP.createNode(defensesTypesContent, 'mma-athlete-info-view__block-part mma-athlete-info-view__block-part-table');
		this.defensesTypesChartWrapper = NP.createNode(defensesTypesPart1, 'mma-athlete-info-view__chart-wrapper mma-athlete-info-view__chart-wrapper-defenses-types');
		this.defensesTypesTableWrapper = NP.createNode(defensesTypesPart2, 'mma-athlete-info-view__table-wrapper mma-athlete-info-view__table-wrapper-defenses-types');

		// 11. Defenses efficiency
		NP.createNode(this._mainContainer).style.pageBreakBefore = 'always';
		this.defensesEfficiencyBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__block mma-athlete-info-view__defenses-efficiency-block');
		let defensesEfficiencyCaption = NP.createNode(this.defensesEfficiencyBlock, 'mma-athlete-info-view__block-caption');
		defensesEfficiencyCaption.innerText = NP.RM.getString("MMAAthleteProfileReport_DefensesEfficiencyCaption");
		let defensesEfficiencyContent = NP.createNode(this.defensesEfficiencyBlock, 'mma-athlete-info-view__block-content');
		this.defensesEfficiencyEl = this.createSingleValue(defensesEfficiencyContent, "");

		// 12. Missed strikes
		this.missedStrikesZonesBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__block mma-athlete-info-view__missed-strikes-zones-block');
		let missedStrikesZonesCaption = NP.createNode(this.missedStrikesZonesBlock, 'mma-athlete-info-view__block-caption');
		missedStrikesZonesCaption.innerText = NP.RM.getString("MMAAthleteProfileReport_missedStrikesZonesCaption");
		let missedStrikesZonesContent = NP.createNode(this.missedStrikesZonesBlock, 'mma-athlete-info-view__block-content');
		let missedStrikesZonesPart1 = NP.createNode(missedStrikesZonesContent, 'mma-athlete-info-view__block-part');
		let missedStrikesZonesPart2 = NP.createNode(missedStrikesZonesContent, 'mma-athlete-info-view__block-part');
		let missedStrikesZonesThrownContainer = NP.createNode(missedStrikesZonesPart1, 'mma-athlete-info-view__mma-punches-body-view-container');
		let missedStrikesZonesThrownCaption = NP.createNode(missedStrikesZonesThrownContainer, 'mma-athlete-info-view__mma-punches-body-view-caption');
		missedStrikesZonesThrownCaption.innerHTML = NP.RM.getString("MMAAthleteProfileReport_StrikesZonesCaptionThrown");
		this.missedStrikesZonesViewThrown = new MmaPunchesBodyView({
			ParentNode: missedStrikesZonesThrownContainer,
			Class: "mma-athlete-info-view__mma-punches-body-view"
		});
		let missedStrikesZonesLandedContainer = NP.createNode(missedStrikesZonesPart2, 'mma-athlete-info-view__mma-punches-body-view-container');
		let missedStrikesZonesLandedCaption = NP.createNode(missedStrikesZonesLandedContainer, 'mma-athlete-info-view__mma-punches-body-view-caption');
		missedStrikesZonesLandedCaption.innerHTML = NP.RM.getString("MMAAthleteProfileReport_StrikesZonesCaptionLanded");
		this.missedStrikesZonesViewLanded = new MmaPunchesBodyView({
			ParentNode: missedStrikesZonesLandedContainer,
			Class: "mma-athlete-info-view__mma-punches-body-view"
		});

		// 13. Takedowns defense efficiency
		this.takedownsDefenseBlock = NP.createNode(this._mainContainer, 'mma-athlete-info-view__block mma-athlete-info-view__takedowns-defense-block');
		let takedownsDefenseCaption = NP.createNode(this.takedownsDefenseBlock, 'mma-athlete-info-view__block-caption');
		takedownsDefenseCaption.innerText = NP.RM.getString("MMAAthleteProfileReport_TakedownsDefenseCaption");
		let takedownsDefenseContent = NP.createNode(this.takedownsDefenseBlock, 'mma-athlete-info-view__block-content');
		let takedownsDefensePart1 = NP.createNode(takedownsDefenseContent, 'mma-athlete-info-view__block-part');
		let takedownsDefensePart2 = NP.createNode(takedownsDefenseContent, 'mma-athlete-info-view__block-part mma-athlete-info-view__block-part-table');
		this.takedownsDefenseChartWrapper = NP.createNode(takedownsDefensePart1, 'mma-athlete-info-view__chart-wrapper mma-athlete-info-view__chart-wrapper-takedowns-defense');
		this.takedownsDefenseTableWrapper = NP.createNode(takedownsDefensePart2, 'mma-athlete-info-view__table-wrapper mma-athlete-info-view__table-wrapper-takedowns-defense');

		this.refresh();
		this.refreshData();

		if (this._ParentNode)
			this.putToNode(this._ParentNode);
	}

	refresh()
	{
		let text = this._getCaptionText();
		this._caption.innerText = text;
		this.battleAthleteNameEl.innerText = text;
	}

	async refreshData(): Promise<any>
	{
		if (!this._Athlete)
			return;

		if (!(window as any).Highcharts)
			return loadFile('highcharts.js').then(() => this.isLive() && this.refreshData());

		this.clear();

		this.startLoading();
		try
		{
			await this.loadBattles();
			await this.loadData();
		} finally
		{
			this.endLoading();
		}
	}

	setCaption(value: string)
	{
		this._caption.innerText = value;
	}

	setAthlete(value: IAthlete)
	{
		this._Athlete = value;
		this.refresh();
		this.updateInfo();
	}

	private _getCaptionText()
	{
		if (this._Athlete)
		{
			let isRu = NP.getCurrentUser().getRegionalSettings().Lang == 'ru';
			let firstName = isRu ? (this._Athlete.FirstNameRU || this._Athlete.FirstName) : this._Athlete.FirstName;
			let lastName = isRu ? (this._Athlete.LastNameRU || this._Athlete.LastName) : this._Athlete.LastName;
			let athleteName = firstName || '';
			if (firstName)
				athleteName += ' ' + (lastName || '');
			return athleteName;
		}
		else
			return '';
	}

	private clearBattleData()
	{
		[
			this.strikesAccuracyChart,
			this.strikesTypesChart,
			this.strikesTypesLandedChart,
			this.takedownsAccuracyChart,
			this.positionTimeChart,
			this.defensesTypesChart,
			this.takedownsDefenseChart
		].forEach(x =>
		{
			try
			{
				x && x.destroy && x.destroy();
			} catch (e)
			{
			}
		});

		[
			this.strikesAccuracyTable,
			this.strikesTypesTable,
			this.strikesTypesLandedTable,
			this.strikesEfficiencyTable,
			this.takedownsAccuracyTable,
			this.positionTimeTable,
			this.controlTable,
			this.defensesTypesTable,
			this.takedownsDefenseTable,
		].forEach(x =>
		{
			try
			{
				x && x.remove && x.remove();
			} catch (e)
			{
			}
		});

		this.strikesSpeedEl.innerHTML = '';
		this.strikesSpeedLandedEl.innerHTML = '';
		this.defensesEfficiencyEl.innerHTML = '';

		this.strikesZonesViewThrown.clear();
		this.strikesZonesViewLanded.clear();
		this.missedStrikesZonesViewThrown.clear();
		this.missedStrikesZonesViewLanded.clear();
	}

	clear()
	{
		this.clearBattleData();
		this.setPhotoAndFlag('', '');
		this.setOpponentPhotoUrl('');
	}

	private startLoading()
	{
		if (this._loading === 0)
		{
			this._oldAppBarCaption = this._topAppBar.getCaption();
		}
		this._loading++;
		this._topAppBar.showWaiter();
		this._topAppBar.setCaption(NP.RM.getString('Loading3Dot'));
		showWaiterAnyWay();
	}

	private endLoading()
	{
		this._loading--;
		if (this._loading <= 0)
		{
			this._topAppBar.setCaption(this._oldAppBarCaption);
			this._topAppBar.hideWaiter();
			hideWaiter();
		}
	}

	async loadData(): Promise<any>
	{
		let data: IMMAAthleteProfileReportData = await this.loadBattleData();
		//let flagUrl = data.FlagUrl;
		//if (!flagUrl)


		if (data.FlagUrl)
		{
			this.setPhotoAndFlag(data.PhotoUrl, data.FlagUrl);
		}
		else if (this._Athlete.CountryISO)
		{
			let flagUrl = NP.getCurrentUser().getAppSettings().CountryFlagFolder + this._Athlete.CountryISO + `.png`;

			this.setPhotoAndFlag(data.PhotoUrl, flagUrl);
		}

	}

	private async loadBattleData(): Promise<IMMAAthleteProfileReportData>
	{
		let curBattleId = this.getCurrentBattleId();
		let data = await ServerAPI.get(`/mma-report/getMMAAthleteProfileReportData/${this._Athlete.Id}?${curBattleId != null ? 'battleId=' + curBattleId : ''}`) as IMMAAthleteProfileReportData

		// [
		// 	data.StrikesAccuracy,
		// 	data.StrikesAccuracyTable,
		// 	data.StrikesTypes,
		// 	data.StrikesTypesLanded,
		// 	data.TakedownsAccuracy,
		// 	data.PositionTime,
		// 	data.DefensesTypes,
		// 	data.TakedownsDefense
		// ].forEach(x =>
		// {
		// 	this.transformSlotsResources(x);
		// });
		this.recordDataStat = null;
		this.recordData = await ServerAPI.get(`/athlete/calcRecords/${this._Athlete.Id}`) as any;

		this.infoWinRecordEl.innerText = this.recordData.WIN + '';
		this.infoLoseRecordEl.innerText = this.recordData.LOSE + '';
		this.infoDrawRecordEl.innerText = this.recordData.DRAW + '';
		this.infoCancelledRecordEl.innerText = this.recordData.CANCELLED + '';

		if (this.recordData.WIN > 0)
		{
			NP.addCssClass(this.infoWinRecordEl, 'link-td');
			this._addEvent(this.infoWinRecordEl, "click", () => this.showRecordDataDialog('WIN'))
		}

		if (this.recordData.LOSE > 0)
		{
			NP.addCssClass(this.infoLoseRecordEl, 'link-td');
			this._addEvent(this.infoLoseRecordEl, "click", () => this.showRecordDataDialog('LOSE'))
		}

		if (this.recordData.DRAW > 0)
		{
			NP.addCssClass(this.infoDrawRecordEl, 'link-td');
			this._addEvent(this.infoDrawRecordEl, "click", () => this.showRecordDataDialog('DRAW'))
		}

		if (this.recordData.CANCELLED > 0)
		{
			NP.addCssClass(this.infoCancelledRecordEl, 'link-td');
			this._addEvent(this.infoCancelledRecordEl, "click", () => this.showRecordDataDialog('Canceled'))
		}

		this.setOpponentPhotoUrl(data.OpponentPhotoUrl);
		this.updateCaption();
		this.updateBattleInfo();

		if (curBattleId != null)
		{
			NP.showNode(this.battlePhotosBlock);
			NP.hideNode(this.photoFlagBlock);
		}
		else
		{
			NP.hideNode(this.battlePhotosBlock);
			NP.showNode(this.photoFlagBlock);
		}

		this.strikesAccuracyChart = this.getChart(this.strikesAccuracyChartWrapper, data.StrikesAccuracy);
		this.strikesAccuracyTable = this.createTable(this.strikesAccuracyTableWrapper, data.StrikesAccuracyTable);
		this.strikesTypesChart = this.getChart(this.strikesTypesChartWrapper, data.StrikesTypes);
		this.strikesTypesTable = this.createTable(this.strikesTypesTableWrapper, data.StrikesTypesTable, NP.RM.getString("MMAAthleteProfileReport_StrikeType"));
		this.strikesTypesLandedChart = this.getChart(this.strikesTypesLandedChartWrapper, data.StrikesTypesLanded);
		this.strikesTypesLandedTable = this.createTable(this.strikesTypesLandedTableWrapper, data.StrikesTypesLandedTable, NP.RM.getString("MMAAthleteProfileReport_StrikeType"));
		this.strikesEfficiencyTable = this.createTable(this.strikesEfficiencyTableWrapper, data.StrikesEfficiencyTable, NP.RM.getString("MMAAthleteProfileReport_StrikeType"));
		this.strikesSpeedEl.innerHTML = (Math.round(data.StrikesSpeedAll * 100) / 100).toString();
		this.strikesSpeedLandedEl.innerHTML = (Math.round(data.StrikesSpeedLanded * 100) / 100).toString();
		this.strikesZonesViewThrown.setZonesData(this.toStrikesZonesData(data.StrikesZones, false));
		this.strikesZonesViewLanded.setZonesData(this.toStrikesZonesData(data.StrikesZones, true));
		this.takedownsAccuracyChart = this.getChart(this.takedownsAccuracyChartWrapper, data.TakedownsAccuracy);
		this.takedownsAccuracyTable = this.createTable(this.takedownsAccuracyTableWrapper, data.TakedownsAccuracyTable);
		this.positionTimeChart = this.getChart(this.positionTimeChartWrapper, data.PositionTime);
		let posTimeFmt = (seconds: number, columnIndex: number) => secondsToTime(seconds);
		this.positionTimeTable = this.createTable(this.positionTimeTableWrapper, data.PositionTimeTable, NP.RM.getString("MMAAthleteProfileReport_Position"), "", posTimeFmt);
		let controlTableFmt = (val: number, columnIndex: number) => columnIndex <= 1 ? secondsToTime(val) : this.round2(val);
		this.controlTable = this.createTable(this.controlTableWrapper, data.ControlTable, NP.RM.getString("MMAAthleteProfileReport_Position"), "", controlTableFmt);
		this.defensesTypesChart = this.getChart(this.defensesTypesChartWrapper, data.DefensesTypes);
		this.defensesEfficiencyEl.innerHTML = `${Math.round(data.DefensesEfficiency * 10000) / 100}%`;
		this.missedStrikesZonesViewThrown.setZonesData(this.toStrikesZonesData(data.MissedStrikesZones, false));
		this.missedStrikesZonesViewLanded.setZonesData(this.toStrikesZonesData(data.MissedStrikesZones, true));
		this.defensesTypesTable = this.createTable(this.defensesTypesTableWrapper, data.DefensesTypesTable, NP.RM.getString("MMAAthleteProfileReport_DefensesTypes"));
		this.takedownsDefenseChart = this.getChart(this.takedownsDefenseChartWrapper, data.TakedownsDefense);
		this.takedownsDefenseTable = this.createTable(this.takedownsDefenseTableWrapper, data.TakedownsDefenseTable);

		return data;
	}

	async showRecordDataDialog(res: string)
	{
		if (!this.recordDataStat)
			this.recordDataStat = await ServerAPI.callUiApi(`/athlete/getRecordData/${this._Athlete.Id}`) as RecordData[];


		let dlg = new Dialog({
			ShowHeader: true,
			Width: 900,
			Mode: 'FullHeight',
			Caption: NP.RM.getString('FightHistory'),
			Class: 'nopad ',
			ContentAutoFit: true,
			Content: new DataTable({
				Class: `mdc-data-table--margin`,
				Rows: this.recordDataStat.filter(a => a.Result == res),
				Columns: [{
					Content: NP.RM.getString('Date'),
					Width: '20%',
					PropertyContent: 'Date'
				}, {
					Content: NP.RM.getString('Result'),
					PropertyContent: 'Result',
					Width: '20%'
				}, {
					Content: NP.RM.getString('Opponent'),
					PropertyContent: 'Opponent',
					Width: '30%'
				}, {
					Content: NP.RM.getString('WinType2'),
					PropertyContent: 'WinType',
					Width: '10%'
				}, {
					Content: NP.RM.getString('Time'),
					PropertyContent: 'EndTime',
					Width: '20%'
				}, {
					Content: NP.RM.getString('Round'),
					PropertyContent: 'Round',
					Width: '10%'
				}]
			})
		});

		dlg._contentNode.style.overflow = 'hidden'
		dlg.show();
		dlg.getCancelButton().setIsVisible(false);

	}

	async loadBattles(): Promise<any>
	{
		this._battleSelect.clearSelection();
		this._battleSelect.clear();
		return ServerAPI.post(`/battle/items`, {
			AthleteId: this._Athlete.Id,
			SportType: SportType.MMA
		}).then((response: IBattlesResponse) =>
		{
			this._battles = response.List;


			let win = 0, draw = 0, loss = 0, roundCount = 0;

			response.List.filter(b => b.Status == "Finished").forEach(b =>
			{
				if (b.Winner == this._Athlete.Id)
					win++;
				else if (!b.Winner)
					draw++;
				else
					loss++;

				roundCount += b.WinRound
			})

			this.infoBoutCount.innerText = this._battles.length + ' (' + roundCount + ')';

			this.analInfoEl.innerHTML = `
			<table class="mma-athlete-info-view__record-table">
				<tbody>
					<tr>
						<td class='mma-athlete-info-view__record-table-td mma-athlete-info-view__win-record'>${win}</td>
						<td class='mma-athlete-info-view__record-table-td mma-athlete-info-view__lose-record'>${loss}</td>
						<td class='mma-athlete-info-view__record-table-td mma-athlete-info-view__draw-record'>${draw}</td>
					</tr>
					<tr>
						<td class='mma-athlete-info-view__record-table-td'>${NP.RM.getString('WinRecord')}</td>
						<td class='mma-athlete-info-view__record-table-td'>${NP.RM.getString('LoseRecord')}</td>
						<td class='mma-athlete-info-view__record-table-td'>${NP.RM.getString('DrawRecord')}</td>
					</tr>
				</tbody>
			</table>
		`;

			let itemsObjs: { id: number, name: string, date: Moment }[] = this._battles.map(x => ({
				id: x.Id,
				name: (x.Red === this._Athlete.Id) ? x.BlueName : x.RedName,
				date: moment(x.Date),
			}));

			itemsObjs.sort((a, b) => a.name < b.name ? -1 : (a.name > b.name ? 1 : (a.date.isBefore(b.date) ? -1 : (a.date.isAfter(b.date) ? 1 : 0))));

			// Добавляем к повторяющимся противникам дату боя
			for (let i = 0; i < itemsObjs.length; i++)
			{
				let hasSameName = false;
				for (let j = i + 1; j < itemsObjs.length; j++)
				{
					if (itemsObjs[i].name === itemsObjs[j].name)
					{
						itemsObjs[j].name += ` (${itemsObjs[j].date.format(NP.getDayFormat())})`;
						hasSameName = true;
					}
				}
				if (hasSameName)
				{
					itemsObjs[i].name += ` (${itemsObjs[i].date.format(NP.getDayFormat())})`;
				}
			}

			this._battleSelect.addItems([{
				Value: -1,
				RK: 'All'
			}, ...itemsObjs.map(x => ({
				Value: x.id,
				Content: x.name
			}))]);
		});
	}

	private getChart(wrapper: HTMLElement, data: IPunchesData): object
	{
		return (window as any).Highcharts.chart(wrapper, this.getPieChartData(data));
	}

	private getPieChartData(data: IPunchesData): object
	{
		let json: any = getPieChartData(data);
		json.colors = ['#4E7BA7', '#F28E2B', '#E15757', '#76B7B2', '#56A14F', '#EDD248', '#B07A9E', '#FF9DA5', '#9C735F', '#BAB1AC'];
		return json;
	}

	/**
	 * Заменяет строки в data.TopSlots и data.LeftSlots на строки из ресурсов
	 * @param data
	 */
	private transformSlotsResources(data: IPunchesData): IPunchesData
	{
		let func = (x: string) =>
		{
			let res = NP.RM.getString(x);
			return res || x;
		};
		data.TopSlots = data.TopSlots.map(func);
		data.LeftSlots = data.LeftSlots.map(func);
		return data;
	}

	private createTable(parentNode: HTMLElement, slice: IPunchesData, caption?: string, className?: string, formatValue?: (cellValue: number, columnIndex: number) => number | string): HTMLTableElement
	{
		className = className ? (' ' + className.trim()) : '';
		caption = caption || '';
		let table = NP.createNode(parentNode, 'mma-athlete-info-view__table' + className, 'table');
		let thead = NP.createNode(table, undefined, 'thead');
		let theadRow = NP.createNode(thead, undefined, 'tr');
		NP.createNode(theadRow, "mma-athlete-info-view__table-th", 'th').innerHTML = NP.escapeHTML(caption);
		slice.TopSlots.forEach(text =>
		{
			NP.createNode(theadRow, "mma-athlete-info-view__table-th", 'th').innerHTML = NP.escapeHTML(text);
		});
		let tbody = NP.createNode(table, undefined, 'tbody');
		slice.LeftSlots.forEach((rowText, row) =>
		{
			let tr = NP.createNode(tbody, undefined, 'tr');
			NP.createNode(tr, "mma-athlete-info-view__table-td mma-athlete-info-view__table-td--head", 'td').innerHTML = NP.escapeHTML(rowText);
			slice.TopSlots.forEach((colText, col) =>
			{
				if (!formatValue)
					formatValue = (cellValue: number, columnIndex: number) => this.round2(cellValue);
				let val = formatValue(slice.Data[row][col], col);
				NP.createNode(tr, "mma-athlete-info-view__table-td", 'td').innerHTML = val;
			});
		});
		return table;
	}

	private createInfoNode(parentNode: HTMLElement): HTMLElement
	{

		let info = NP.createNode(parentNode, 'mma-athlete-info-view__info');

		let recordItem = NP.createNode(info, 'mma-athlete-info-view__info-item');
		let recordCaption = NP.createNode(recordItem, 'mma-athlete-info-view__info-item-caption');

		let baseStyleItem = NP.createNode(info, 'mma-athlete-info-view__info-item');


		recordCaption.innerHTML = NP.RM.getString('Record');
		let recordValue = NP.createNode(recordItem, 'mma-athlete-info-view__info-item-value');
		recordValue.innerHTML = `
			<table class="mma-athlete-info-view__record-table">
				<tbody>
					<tr>
						<td class='mma-athlete-info-view__record-table-td mma-athlete-info-view__win-record'></td>
						<td class='mma-athlete-info-view__record-table-td mma-athlete-info-view__lose-record'></td>
						<td class='mma-athlete-info-view__record-table-td mma-athlete-info-view__draw-record'></td>
						<td class='mma-athlete-info-view__record-table-td mma-athlete-info-view__cancelled-record'></td>
					</tr>
					<tr>
						<td class='mma-athlete-info-view__record-table-td'>${NP.RM.getString('WinRecord')}</td>
						<td class='mma-athlete-info-view__record-table-td'>${NP.RM.getString('LoseRecord')}</td>
						<td class='mma-athlete-info-view__record-table-td'>${NP.RM.getString('DrawRecord')}</td>
						<td class='mma-athlete-info-view__record-table-td'>${NP.RM.getString('BattleCancelled')}</td>
					</tr>
				</tbody>
			</table>
		`;


		baseStyleItem.innerHTML = `
			<div class="mma-athlete-info-view__info-item-caption">${NP.RM.getString('Nickname')}</div>
			<div class="mma-athlete-info-view__info-item-value mma-athlete-info-view__info-item-value-nickname"></div>

			<div class="mma-athlete-info-view__info-item-caption">${NP.RM.getString('Age')}</div>
			<div class="mma-athlete-info-view__info-item-value mma-athlete-info-view__info-item-value-age"></div>

			<div class="mma-athlete-info-view__info-item-caption">${NP.RM.getString('WeightCategory')}</div>
			<div class="mma-athlete-info-view__info-item-value mma-athlete-info-view__info-item-value-weight"></div>			
			
			<div class="mma-athlete-info-view__info-item-caption">${NP.RM.getString('BaseStyle')}</div>
			<div class="mma-athlete-info-view__info-item-value mma-athlete-info-view__info-item-value-base-style"></div>
			
				<div class="mma-athlete-info-view__info-item-caption">${NP.RM.getString('HeightAthlete')}</div>
			<div class="mma-athlete-info-view__info-item-value mma-athlete-info-view__info-item-value-height"></div>
			
			
			<div class="mma-athlete-info-view__info-item-caption">${NP.RM.getString('ArmSpan')}</div>
			<div class="mma-athlete-info-view__info-item-value mma-athlete-info-view__info-item-value-armspan"></div>
			
			<div class="mma-athlete-info-view__info-item-caption">${NP.RM.getString('BoutAnalyze')}</div>
			<div class="mma-athlete-info-view__info-item-value mma-athlete-info-view__info-item-value-bout-anal"></div>
		
			<div class="mma-athlete-info-view__info-item-value mma-athlete-info-view__info-item-value-bout-anal-record"></div>
			
		`;

		this.infoHeightEl = info.querySelector('.mma-athlete-info-view__info-item-value-height');
		this.infoWeightEl = info.querySelector('.mma-athlete-info-view__info-item-value-weight');
		this.infoWinRecordEl = info.querySelector(".mma-athlete-info-view__win-record");
		this.infoLoseRecordEl = info.querySelector(".mma-athlete-info-view__lose-record");
		this.infoDrawRecordEl = info.querySelector(".mma-athlete-info-view__draw-record");
		this.infoCancelledRecordEl = info.querySelector(".mma-athlete-info-view__cancelled-record");
		this.infoBaseStyleEl = info.querySelector(".mma-athlete-info-view__info-item-value.mma-athlete-info-view__info-item-value-base-style");
		this.infoNickNameEl = info.querySelector(".mma-athlete-info-view__info-item-value.mma-athlete-info-view__info-item-value-nickname");
		this.infoarmSpanEl = info.querySelector(".mma-athlete-info-view__info-item-value.mma-athlete-info-view__info-item-value-armspan");
		this.infoAgeEl = info.querySelector(".mma-athlete-info-view__info-item-value.mma-athlete-info-view__info-item-value-age");

		this.infoBoutCount = info.querySelector(".mma-athlete-info-view__info-item-value.mma-athlete-info-view__info-item-value-bout-anal");


		this.analInfoEl = info.querySelector(".mma-athlete-info-view__info-item-value.mma-athlete-info-view__info-item-value-bout-anal-record");

		this.updateInfo();

		return info;
	}

	private toStr = (value: any, emptyValue: string = "-"): string => value == undefined || value === "" ? emptyValue : value + "";

	private updateInfo()
	{
		this.infoHeightEl.innerText = this.toStr(this._Athlete.Height);
		this.infoWeightEl.innerText = this.toStr(getWeightStringById(this._Athlete.WeightCategory));
		this.infoBaseStyleEl.innerText = this.toStr(this._Athlete.BaseStyle);

		this.infoNickNameEl.innerText = this.toStr(this._Athlete.Nickname);
		this.infoarmSpanEl.innerText = this.toStr(this._Athlete.ArmSpan);
		if (this._Athlete.DateBirth)
			this.infoAgeEl.innerText = moment().diff(moment(this._Athlete.DateBirth), 'years', false) + '';
	}

	private createBattleInfoNode(parentNode: HTMLElement): HTMLElement | null
	{
		let battleInfo = NP.createNode(parentNode, 'mma-athlete-info-view__info');
		battleInfo.innerHTML = `
			<div class="mma-athlete-info-view__info-item">
				<div class="mma-athlete-info-view__info-item-caption">${NP.RM.getString("Tournament")}</div>
				<div class="mma-athlete-info-view__info-item-value mma-athlete-info-view__battle-info-item-value-tournament">
				</div>
			</div>
			<div class="mma-athlete-info-view__info-item">
				<div class="mma-athlete-info-view__info-item-caption">${NP.RM.getString("Date")}</div>
				<div class="mma-athlete-info-view__info-item-value mma-athlete-info-view__battle-info-item-value-date">
				</div>
			</div>
			<div class="mma-athlete-info-view__info-item">
				<div class="mma-athlete-info-view__info-item-caption">${NP.RM.getString("Winner")}</div>
				<div class="mma-athlete-info-view__info-item-value mma-athlete-info-view__battle-info-item-value-winner">
				</div>
			</div>
			<div class="mma-athlete-info-view__info-item">
				<div class="mma-athlete-info-view__info-item-caption">${NP.RM.getString('WinType').replace("{0}:", "")}</div>
				<div class="mma-athlete-info-view__info-item-value mma-athlete-info-view__battle-info-item-value-win">
				</div>
			</div>
		`;
		this.battleInfoTournamentEl = battleInfo.querySelector('.mma-athlete-info-view__battle-info-item-value-tournament');
		this.battleInfoDateEl = battleInfo.querySelector('.mma-athlete-info-view__battle-info-item-value-date');
		this.battleInfoWinnerEl = battleInfo.querySelector('.mma-athlete-info-view__battle-info-item-value-winner');
		this.battleInfoWinEl = battleInfo.querySelector('.mma-athlete-info-view__battle-info-item-value-win');
		this.updateBattleInfo();
		return battleInfo;
	}

	private updateBattleInfo()
	{
		let battle: IBattle | any = this.getCurrentBattle() || {};
		this.battleInfoTournamentEl.innerText = this.toStr(battle.Tournament);
		this.battleInfoDateEl.innerText = this.toStr(battle.Date ? moment(battle.Date).format(NP.getDayFormat()) : undefined);
		this.battleInfoWinnerEl.innerText = this.toStr(battle.WinnerName);
		this.battleInfoWinEl.innerText = this.toStr(battle.WinType ? NP.RM.getString(`WinType_${battle.WinType}`) : undefined);
	}

	private updateCaption()
	{
		let battle = this.getCurrentBattle();
		if (battle)
		{
			NP.hideNode(this._caption);
			this.battleOpponentNameEl.innerText = battle.Red === this._Athlete.Id ? battle.BlueName : battle.RedName;
		}
		else
		{
			NP.showNode(this._caption);
		}
	}

	/**
	 * Возвращает число, округлённое до двух знаков после запятой.
	 * @param val
	 */
	private round2(val: number): number
	{
		return Math.round(val * 100) / 100;
	}


	private createSingleValue(parentNode: HTMLElement, value: string, caption?: string, className?: string): HTMLDivElement
	{
		className = className ? (className.trim() || '') : '';
		caption = caption ? (caption.trim() || '') : '';
		let mainEl = NP.createNode(parentNode, `mma-athlete-info-view__single-value${className ? (" " + className) : ''}`);
		if (caption)
		{
			let captionEl = NP.createNode(mainEl, "mma-athlete-info-view__single-value-caption");
			captionEl.innerHTML = NP.escapeHTML(caption);
		}
		let textEl = NP.createNode(mainEl, "mma-athlete-info-view__single-value-text");
		textEl.innerHTML = NP.escapeHTML(value);
		return textEl;
	}

	private transformZonesToPercent(data: IMmaBodyData): IMmaBodyData
	{
		if (!data)
			return null;

		let {head, torso, legs} = data;
		let headTotal = Number(head.total);
		let torsoTotal = Number(torso.total);
		let legsTotal = Number(legs.total);
		let headSuccess = Number(head.success);
		let torsoSuccess = Number(torso.success);
		let legsSuccess = Number(legs.success);
		let total: number = headTotal + torsoTotal + legsTotal;
		let success: number = headSuccess + torsoSuccess + legsSuccess;
		let fmt = (x: number): string => Math.round(x * 100) + '%';
		let div = (x: number, y: number) => y > 0 ? (x / y) : 0;
		let percentData = {
			head: {total: fmt(div(headTotal, total)), success: fmt(div(headSuccess, success))},
			torso: {total: fmt(div(torsoTotal, total)), success: fmt(div(torsoSuccess, success))},
			legs: {total: fmt(div(legsTotal, total)), success: fmt(div(legsSuccess, success))},
		};
		return percentData;
	}

	private toStrikesZonesData(data: IMmaBodyData, isLanded: boolean): IMmaBodyData
	{
		if (!data)
			return null;

		isLanded = isLanded == true;
		let {head, torso, legs} = data;
		let headTotal = Number(head.total);
		let torsoTotal = Number(torso.total);
		let legsTotal = Number(legs.total);
		let headSuccess = Number(head.success);
		let torsoSuccess = Number(torso.success);
		let legsSuccess = Number(legs.success);
		let total: number = headTotal + torsoTotal + legsTotal;
		let success: number = headSuccess + torsoSuccess + legsSuccess;
		let fmt = (x: number): string => Math.round(x * 100) + '%';
		let div = (x: number, y: number): number => y > 0 ? (x / y) : 0;
		let percentData = {
			head: {
				total: isLanded ? fmt(div(headSuccess, success)) : fmt(div(headTotal, total)),
				success: isLanded ? headSuccess : headTotal,
			},
			torso: {
				total: isLanded ? fmt(div(torsoSuccess, success)) : fmt(div(torsoTotal, total)),
				success: isLanded ? torsoSuccess : torsoTotal,
			},
			legs: {
				total: isLanded ? fmt(div(legsSuccess, success)) : fmt(div(legsTotal, total)),
				success: isLanded ? legsSuccess : legsTotal,
			},
		};
		return percentData;
	}

	private async setOpponentPhotoUrl(url: string): Promise<void>
	{
		if (this.opponentPhotoUrl !== url)
		{
			this.opponentPhotoUrl = url;
			if (!url)
			{
				this.photoRight.style.backgroundImage = '';
			}
			else
			{
				this.photoRight.style.backgroundImage = '';
				this.photoRight.style.backgroundImage = `url(${url})`;
			}
		}
	}

	private async setPhotoAndFlag(photoUrl: string, flagUrl: string)
	{
		if (photoUrl)
		{
			this.photo.style.backgroundImage = `url(${photoUrl})`;
			this.photoLeft.style.backgroundImage = `url(${photoUrl})`;
		}
		else
		{
			this.photo.style.backgroundImage = '';
			this.photoLeft.style.backgroundImage = '';
		}

		if (flagUrl)
		{
			this.flag.style.backgroundImage = `url(${flagUrl})`;
		}
		else
		{
			this.flag.style.backgroundImage = '';
		}
	}


	private _onBattleSelected = async (s: object, e: ISelectItemArgs) =>
	{
		this.clearBattleData();
		try
		{
			// this.opponent = await th
			await this.loadBattleData();
		} finally
		{
			this.endLoading();
		}
	}

	private getCurrentBattleId(): number | null
	{
		let battle = this._battleSelect.getValue();
		if (battle == null || battle < 1)
			battle = null;
		return battle;
	}

	private getCurrentBattle(): IBattle | null
	{
		let battleId = this.getCurrentBattleId();
		let battle = battleId ? this._battles.find(x => x.Id === battleId) : null;
		return battle;
	}

	async newExportClick()
	{
		export2pdf(this._mainContainer, this._getCaptionText())
	}

	// private async onExportButtonClick()
	// {
	// 	return this.newExportClick();
	//
	// 	let A4Coef = 210 / 297;
	// 	let pageWidth = 1380;
	// 	let pageHeight = pageWidth * A4Coef;
	//
	// 	this._preRenderWidth = this._Width;
	// 	let oldFlex = this._root.style.flex;
	// 	this._root.style.flex = 'none';
	// 	this.setWidth(pageWidth);
	//
	// 	let successFunc = (s2: any) =>
	// 	{
	// 		let name = this._Athlete.FirstName + ' ' + this._Athlete.LastName;
	// 		NP.downloadFile(NP.Config.ExportURL + "dl?id=" + s2.data + "&name=" + encodeURIComponent(name) + ".pdf");
	// 		this.endLoading();
	// 	};
	// 	let errFunc = (sender: any, e: any) =>
	// 	{
	// 		this.endLoading();
	// 	};
	//
	// 	let nodes: HTMLElement[] = [
	// 		this._caption,
	// 		this.photoFlagBlock,
	// 		this.battlePhotosBlock,
	// 		this.strikesAccuracyBlock,
	// 		this.strikesTypesBlock,
	// 		this.strikesTypesLandedBlock,
	// 		this.strikesEfficiencyBlock,
	// 		this.strikesSpeedBlock,
	// 		this.strikesZonesBlock,
	// 		this.takedownsAccuracyBlock,
	// 		this.positionTimeBlock,
	// 		this.controlBlock,
	// 		this.defensesTypesBlock,
	// 		this.defensesEfficiencyBlock,
	// 		this.missedStrikesZonesBlock,
	// 		this.takedownsDefenseBlock,
	// 	];
	//
	// 	let nodesForExport: SVGExportResult[] = [];
	//
	// 	nodes.forEach((node, i) =>
	// 	{
	// 		let pageBreakAfter = 'auto';
	// 		let res = node.cloneNode(true) as HTMLElement;
	// 		synchronizeCssStyles(node, res);
	// 		res.style.cssText = getComputedCSSText(node);
	// 		res.style.pageBreakInside = "avoid";
	// 		res.style.pageBreakAfter = pageBreakAfter;
	// 		nodesForExport.push({Node: res});
	// 	});
	// 	let content = nodesForExport.map(x => x.Node.outerHTML).join(" ");
	// 	let bodyStyleObj = document.defaultView.getComputedStyle(document.body, "");
	// 	let bodyStyle = `font-family: ${bodyStyleObj.fontFamily}; position: relative;`;
	//
	// 	let thaHeader = '';
	// 	let thaFooter = '';
	// 	let pageHeaderHeight = 0;
	// 	let pageFooterHeight = 0;
	// 	let pageMarginTop = 30;
	// 	let pageMarginBottom = 20;
	//
	// 	Font.getAllFontsRules().then((cssRules: string) =>
	// 	{
	// 		let html = '<!DOCTYPE html>' +
	// 			 '<html xmlns="http://www.w3.org/1999/xhtml">' +
	// 			 '<head>' +
	// 			 '<meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>' +
	// 			 `<style rel="stylesheet" type="text/css">
	// 				@media print {
	// 					@page {size: ${pageWidth}px ${pageHeight}px; margin: ${pageMarginTop}px 20px ${pageMarginBottom}px 20px; }
	// 					.athlete-info-view__tha-header { position: fixed; top: 0; width: 100%; }
	// 					.athlete-info-view__tha-header-img {
	// 						height: 64px;
	// 						width: 64px;
	// 						margin-right: 4px;
	// 						background-image: url("data:image/png;base64,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");
	// 						background-repeat: no-repeat;
	// 						background-size: 100% 100%;
	// 					}
	// 					.athlete-info-view__tha-footer {
	// 						position: fixed;
	// 						bottom: 0;
	// 						right: 0;
	// 						width: 359px;
	// 					}
	// 					.athlete-info-view__tha-footer-img
	// 					{
	// 						height: 55px;
	// 						width: 349px;
	// 						margin-bottom: 9px;
	// 						margin-right: 10px;
	// 						background-image: url("data:image/png;base64,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");
	// 						background-repeat: no-repeat;
	// 					}
	// 					.page-header-space, .athlete-info-view__tha-header { height: ${pageHeaderHeight}px; }
	// 					.page-footer-space, .athlete-info-view__tha-footer { height: ${pageFooterHeight}px; }
	// 					.athlete-info-view__page-table thead { display: table-header-group; }
	// 					.athlete-info-view__page-table tfoot { display: table-footer-group; }
	// 				}
	// 				@font-face {
	// 				  font-family: 'icons';
	// 				  src: url(/static/img/icons.woff?v=2) format('woff');
	// 				  font-weight: normal;
	// 				  font-style: normal;
	// 				}
	//
	// 				${cssRules}
	// 				.ic_arrow_downward:before {
	// 				  content: "\\ea43";
	// 				}
	// 				.ic_arrow_upward:before {
	// 				  content: "\\ea3e";
	// 				}
	// 		 	 </style>` +
	// 			 '</head>' +
	// 			 `<body style="${bodyStyle}">
	// 					${thaHeader}
	// 					${thaFooter}
	// 					<table class="athlete-info-view__page-table">
	// 						<thead><tr><td><div class="page-header-space"></div></td></tr></thead>
	// 					 	<tbody><tr><td>${content}</td></tr></tbody>
	// 						<tfoot><tr><td><div class="page-footer-space"></div></td></tr></tfoot>
	// 				 	</table>
	// 				</body>` +
	// 			 '</html>';
	// 		BattleInfoView.prototype._sendExportHTML2PDF(html, successFunc, errFunc);
	// 	});
	// 	this.setWidth(this._preRenderWidth);
	// 	this._root.style.flex = oldFlex;
	// }
}
